export default __webpack_public_path__ + "static/media/yellow-roses.4cdd2517.jpg";